import React from 'react';

import { Box, SxProps } from '@mui/material';
import Image from 'next/image';

import { grayColors } from '~components/theme/styles/colors';
import { getAssetConfig } from '~config/protocol';
import { AllVestaAssets } from '~config/types';
export const AssetIcon = ({
  sx,
  fullGradient,
  asset,
  round,
  zIndex,
  size,
  noBorder,
  noBg,
}: {
  asset: AllVestaAssets;
  sx?: SxProps;
  zIndex?: number;
  size?: number;
  round?: boolean;
  fullGradient?: boolean;
  noBorder?: boolean;
  noBg?: boolean;
}) => {
  const cfg = getAssetConfig(asset).styles;
  const style = {
    src: cfg.iconSrc ? (fullGradient ? cfg.iconSrc.dark : cfg.iconSrc.light) : '',
    gradient: cfg.gradient,
  };

  const actualContainerSize = noBg && noBorder ? (size ? size : '30px') : size ? `${size + 10}px` : '40px';

  return (
    <Box sx={{ position: 'relative', width: actualContainerSize, height: actualContainerSize }}>
      {!noBorder ? (
        <Box
          sx={
            !fullGradient
              ? {
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  zIndex: 1 + (zIndex ?? 0),
                  borderRadius: round ? '32px' : '6px',
                  background: noBg ? undefined : style.gradient,
                  width: actualContainerSize,
                  height: actualContainerSize,
                }
              : undefined
          }
        />
      ) : null}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: actualContainerSize,
          height: actualContainerSize,
          borderRadius: round ? '32px' : '6px',
          background: noBg ? undefined : fullGradient ? style.gradient : grayColors[900],
          border: !noBorder ? '1.5px solid transparent' : undefined,
          backgroundClip: 'padding-box',
          position: 'absolute',
          zIndex: 2 + (zIndex ?? 0),
          ...sx,
        }}
      >
        <Image width={size ?? '24px'} height={size ?? '24px'} src={style.src} />
      </Box>
    </Box>
  );
};
